import { render, staticRenderFns } from "./SwiperCenteredSlides2.vue?vue&type=template&id=0ac551ba&"
import script from "./SwiperCenteredSlides2.vue?vue&type=script&lang=js&"
export * from "./SwiperCenteredSlides2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports